import { ajax, get, post } from 'utils/rxfetch'
import { buildURL } from 'utils/urls'

// `companyFilter` selects the tenant. buildURL drops empty params, so the
// `= ''` default sends a bare path and the backend falls back to self.
const createSpearPhishingAgentApi = () => ({
  // Not tenant-scoped: this is the list of tenants to choose from.
  getPsimaCompanies() {
    return get(buildURL('/members-api/psima/partner-companies/'))
  },
  getMonitoringInfo(companyId = '') {
    return get(buildURL('/members-api/psima/monitoring-status/', { companyFilter: companyId }))
  },
  getCampaignsList(levels, page, pageSize, extraParams = {}, companyId = '') {
    return get(
      buildURL(
        '/members-api/psima/cards/',
        {
          // First so it leads the query string, and before the spread so caller
          // params can never redirect the request at another tenant.
          companyFilter: companyId,
          level: levels,
          pageNumber: page,
          pageSize,
          ...extraParams,
        },
        true
      )
    )
  },
  sendSimulations(body, companyId = '') {
    return post(buildURL('/members-api/psima/simulations/', { companyFilter: companyId }), body)
  },
  getLevelCounts(companyId = '') {
    return get(buildURL('/members-api/psima/cards/level-counts/', { companyFilter: companyId }))
  },
  getMetricBanner(companyId = '') {
    return get(buildURL('/members-api/psima/cards/metrics-banner/', { companyFilter: companyId }))
  },
  getSimulationList(listQuery, page, pageSize, companyId = '') {
    return get(
      buildURL(
        '/members-api/psima/simulations/',
        { companyFilter: companyId, ...listQuery, pageNumber: page, pageSize },
        true
      )
    )
  },
  exportSimulations(body, companyId = '') {
    return post(
      buildURL('/members-api/psima/simulations/export/', { companyFilter: companyId }),
      body,
      undefined,
      'blob'
    )
  },
  downloadSimulationsExport(jobId, companyId = '') {
    return ajax({
      url: buildURL('/members-api/psima/simulations/export/download/', {
        companyFilter: companyId,
        jobId,
      }),
      method: 'GET',
      responseType: 'blob',
    })
  },
  getParticipantDetails(id, companyId = '', pageNumber = 1, pageSize = 100) {
    return get(
      buildURL(`/members-api/psima/simulations/${id}/participants/`, {
        companyFilter: companyId,
        pageNumber,
        pageSize,
      })
    )
  },
  getEmailPreview(id, participantId, companyId = '') {
    return get(
      buildURL(`/members-api/psima/simulations/${id}/participants/${participantId}/email-review/`, {
        companyFilter: companyId,
      })
    )
  },
  postEmailFeedback(id, participantId, body, companyId = '') {
    return post(
      buildURL(
        `/members-api/psima/simulations/${id}/participants/${participantId}/email-review/feedback/`,
        { companyFilter: companyId }
      ),
      body
    )
  },
  postCardFeedback(cardId, body, companyId = '') {
    return post(
      buildURL(`/members-api/psima/cards/${cardId}/feedback/`, { companyFilter: companyId }),
      body
    )
  },
  getSimulationsMeta(companyId = '') {
    return get(buildURL('/members-api/psima/simulations/meta/', { companyFilter: companyId }))
  },
  getPsimaSettings(companyId = '') {
    return get(buildURL('/members-api/psima/settings/', { companyFilter: companyId }))
  },
  getPsimaParticipantsInfo(body, companyId = '') {
    return post(
      buildURL('/members-api/psima/participants/info/', { companyFilter: companyId }),
      body
    )
  },
  getPsimaParticipantsCount(body, companyId = '') {
    return post(
      buildURL('/members-api/psima/participants/count/', { companyFilter: companyId }),
      body
    )
  },
  savePsimaSettings(body, companyId = '') {
    return post(buildURL('/members-api/psima/settings/', { companyFilter: companyId }), body)
  },
})

export default createSpearPhishingAgentApi
